<template>
  <div v-if="this.isStay">
    <div class="modal-title">{{ $t('tour_change_residence_time') }}</div>
    <div class="modal-content">
      <p class="mt-4 text-label text-xs">{{ $t('tour_checkin_label') }}</p>
      <checkin-time-select v-model="checkinTime" />
      <p class="mt-4 text-label text-xs">{{ $t('tour_checkout_label') }}</p>
      <checkout-time-select v-model="checkoutTime" />
    </div>
    <div class="modal-button">
      <a class="button-primary block" @click="callback(target.destination, calcVisit(), checkinTime)">{{ $t('tour_setting') }}</a>
    </div>

  </div>
  <div v-else>
    <div class="modal-title">{{ $t('tour_change_residence_time') }}</div>
    <div class="modal-content">
      <p class="text-xs text-label">{{ $t('tour_arrival_time') }}</p>
      <arrival-time-select v-model="arrivalTime" />
      <p class="text-xs text-label mt-4">{{ $t('tour_residence_time_label') }}</p>
      <time-select v-model="time" />
    </div>
    <div class="modal-button">
      <a class="button-primary block" @click="callback(target.destination, time, arrivalTime)">{{ $t('tour_setting') }}</a>
    </div>
  </div>
</template>

<script>
import ArrivalTimeSelect from "./ArrivalTimeSelect"
import TimeSelect from "./TimeSelect"
import CheckoutTimeSelect from "./CheckoutTimeSelect"
import CheckinTimeSelect from "./CheckinTimeSelect"
import moment from 'moment-timezone'
moment.tz.setDefault('Asia/Tokyo')

export default {
  components: {
    ArrivalTimeSelect,
    TimeSelect,
    CheckoutTimeSelect,
    CheckinTimeSelect
  },
  props: {
    target: {
      type: Object,
      required: true
    },
    callback: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      time: this.target.destination.visit,
      arrivalTime: this.target.route.arrivalTime,
      isStay: this.target.destination.isStay,
      checkinTime: this.target.route.arrivalTime,
      checkoutTime: this.target.route.arrivalTime.clone().add(this.target.destination.visit, 'm')
    }
  },
  watch: {
    target: function (val) {
      this.time = val.destination.visit,
      this.arrivalTime = val.route.arrivalTime
      this.isStay = this.target.destination.isStay ? true : false
      this.checkinTime = val.route.arrivalTime
      this.checkoutTime = val.route.arrivalTime.clone().add(val.destination.visit, 'm')
    }
  },
  methods: {
    calcVisit() {
      const visitTime = this.checkoutTime.diff(this.checkinTime, 'minutes', false)
      return visitTime
    }
  }
}
</script>
